import { Box, Button, Header, Icon, Modal, Select, SelectProps, SpaceBetween } from '@amzn/awsui-components-react';
import { FunctionComponent, useEffect } from 'react';
import { useAssignOrderModal } from './useAssignOrderModal';
import { Order } from '@amzn/ito-client';
import { useFlashBarItemsActions } from 'common/UseFlashBarItems/useFlashBarItems';

export interface AssignOrderModalProps {
  onDismiss: (shouldRefreshTable?: boolean) => void;
  orders: Order[];
  flashBarItemsActions: useFlashBarItemsActions;
  procurementMembersSelectOptions: SelectProps.Option[];
}

export const AssignOrderModal: FunctionComponent<AssignOrderModalProps> = (props: AssignOrderModalProps) => {
  const { actions, state: attributes } = useAssignOrderModal(props.orders);

  /* istanbul ignore next */
  const onDismiss = () => {
    props.onDismiss(false);
  };

  /* istanbul ignore next */
  useEffect(() => {
    const prefix = props.orders.length > 1 ? 'Orders' : 'Order';
    if (attributes.error) {
      props.flashBarItemsActions.addErrorFlashBarItem(`${prefix} assignation failed.`, attributes.error.message);
      props.onDismiss(false);
    } else if (attributes.data) {
      props.flashBarItemsActions.addSuccessFlashBarItem(
        `${prefix} succesfully assigned to ${attributes.assignee.value}.`
      );
      props.onDismiss(true);
    }
  }, [attributes.error, attributes.data]);

  /* istanbul ignore next */
  const buildFooter = () => {
    const disableFooter = attributes.isLoading === true;
    const displayAssignButton = !(attributes.error || attributes.data);

    return (
      <SpaceBetween direction="horizontal" size="xs">
        <Button data-testid="close-button" variant="link" onClick={onDismiss} disabled={disableFooter}>
          Close
        </Button>
        {displayAssignButton && (
          <Button
            data-testid="assing-button"
            variant="primary"
            onClick={actions.doAssingOrders}
            data-cy="admin-assign-order-button"
            disabled={disableFooter}
            loading={disableFooter}
          >
            Assign
          </Button>
        )}
      </SpaceBetween>
    );
  };

  const footerElement = buildFooter();

  return (
    <Modal
      data-testid="assing-order-modal"
      onDismiss={onDismiss}
      visible={true}
      header={<Header variant="h2">Assign</Header>}
      footer={<Box float="right">{footerElement}</Box>}
    >
      <Select
        selectedOption={attributes.assignee}
        options={props.procurementMembersSelectOptions}
        onChange={actions.onAssignedChange}
      ></Select>
    </Modal>
  );
};
